import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AssetFile, AssetUrl } from '@brafton/assets-api';
import { ProjectHelper } from 'src/app/core';

@Component({
  selector: 'shared-master-project-image-panel',
  templateUrl: './master-project-image-panel.component.html',
  styleUrls: ['./master-project-image-panel.component.scss'],
  host: { class: 'master-project-image-panel' },
})
export class SharedMasterProjectImagePanelComponent implements OnInit {
  @Input() project?: any;
  @Input() size = 120;
  @Input() details = true;
  @Input() showMembers?: boolean = true;
  @Input() opens: 'Project' | 'Asset' = 'Project';

  assetFile!: AssetFile;

  @Output() loaded = new EventEmitter<boolean>();
  @Output() errored = new EventEmitter<boolean>();

  constructor(private router: Router, private projectHelper: ProjectHelper) {}

  ngOnInit() {
    if (this.project && this.project?.defaultAsset) {
      this.assetFile = this.project?.defaultAsset?.assetFiles[0];
    }
  }

  openLink() {
    if (this.opens === 'Project' && this.project) {
      const route = this.projectHelper.findRoute(this.project);
      this.router.navigate([route]);
    }

    if (this.opens === 'Asset' && this.assetFile) {
      const assetUrlPipe = new AssetUrl();
      window.open(assetUrlPipe.transform(this.assetFile, 'preview'));
    }
  }
}
